//
// Copyright (c) 2020 Astute Global, Inc.
//

define(["marionette", "messaging/messenger", "./basicDepartmentInfoView"], function (
  Marionette,
  Messenger,
  BasicDepartmentInfoView,
) {
  "use strict";

  var BasicDepartmentInfoController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "basicDepartmentInfoModule";
    },
    show: function (department) {
      this.model = department;
      this.view = new BasicDepartmentInfoView.basicDepartmentInfoView({ model: this.model });
      this.view.on(
        "show:history",
        function () {
          Messenger.vent.trigger("department:history", this.model);
        },
        this,
      );
      department.on(
        "invalid",
        function (model, error) {
          if ("name" in error) {
            this.view.nameError(error.name);
          }
        },
        this,
      );
      if (department.isNew()) {
        this.view.on(
          "show",
          function () {
            this.view.enableTextbox("#name");
          },
          this,
        );
      }
      this.showRegion(this.view);
    },
  });

  return BasicDepartmentInfoController;
});
